import classes from './ActionTypeIndicator.module.scss'
import {
  HiOutlineCode,
  HiOutlineLogout
} from 'react-icons/hi'
import { Icons } from '../..'

export interface Props {
  value: 'submodel'|'previous'|'exit'|'snippet'|'defaultAction'
}

export const iconList = {
  submodel:
  <Icons.TestCaseSubModel
    aria-hidden
    size='18'
  />,
  previous:
  <Icons.TestCasePrevious
    aria-hidden
    size='18'
  />,
  exit:
  <HiOutlineLogout
    aria-hidden
    size={18}
  />,
  snippet:
  <HiOutlineCode
    aria-hidden
    size={18}
  />,
  defaultAction:
  <HiOutlineCode
    aria-hidden
    size={18}
  />
}

const ActionTypeIndicator = ({
  value
}: Props) =>
  <div
    aria-label={value}
    className={classes.ActionTypeIndicator + ' ' + classes[value]}
  >
    {iconList[value]}
  </div>

export default ActionTypeIndicator
